import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const themedInputSearchStyles = StyleSheet.create({
	icon: {
		color: colorList.BLACK.light,
		fontSize: 16,
		alignSelf: 'flex-end'
	}
});
